import React from "react";
import StakingPage from "./StakingPage";
import styled from "styled-components";
import video from "../assets/background.mp4";
function App() {
  return (
    <>
      <StakingDappContainer>
        <StakingPage />
      </StakingDappContainer>
    </>
  );
}

export default App;

const StakingDappContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: black;
`;

const VideoWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;
